var _jsxFileName = "/opt/atlassian/pipelines/agent/build/src/components/connection/Partner/PartnerConnection/CommercialApi/HealthDataCommercialApi.tsx";
import React, { useState } from 'react';
import { Divider, HStack, IconInfo, LoadingSpinner, Stack, Text } from '@adc/parallax-component-library';
import { useApiError, useLibrePartner, useToast } from 'Hooks';
import { InfoModal, Link, RichText } from 'Components/utility';
import { getDocumentPathFromLanguage } from 'Utilities/dataHelpers';
import { formatTimestamp } from 'Utilities/dateHelpers';
import i18n from 'Utilities/i18n';
import mediator from 'Utilities/mediator';
import { store } from 'Utilities/store';
const HealthDataCommercialApi = ({
  partnerConnection
}) => {
  const [showModalInfo, setShowModalInfo] = useState(false);
  const [footerLoading, setFooterLoading] = useState(false);
  const {
    showApiErrorModal
  } = useApiError();
  const {
    showToast
  } = useToast();
  const {
    removePartner,
    showStopSharingModal
  } = useLibrePartner();
  const {
    time,
    monthDate
  } = formatTimestamp(partnerConnection.consent.created, i18n.language, 'MMM d, yyyy');
  const onStopSharing = () => {
    showStopSharingModal(partnerConnection.partner.name, 'ConnectedOAuthPartner.modals.stopSharingData.title', 'ConnectedOAuthPartner.modals.stopSharingData.body', async () => {
      try {
        setFooterLoading(true);
        await removePartner(partnerConnection.partner.id);
        showToast({
          message: i18n.t('Global.modals.removeConnection.connectionRemoved'),
          'aria-label': i18n.t('Global.modals.removeConnection.connectionRemoved')
        });
        mediator.publish('router:navigate', '/connections');
      } catch {
        showApiErrorModal();
      } finally {
        setFooterLoading(false);
      }
    });
  };
  const onPrivacyNoticeLinkClick = () => {
    const {
      documentsUrl,
      documents
    } = store.getState().config;
    const {
      language
    } = store.getState().lang;
    const privacyNoticePath = getDocumentPathFromLanguage(documents?.privacypolicy, language);
    if (privacyNoticePath) {
      const privacyNoticeFullUrl = `${documentsUrl}${privacyNoticePath}`;
      window.open(privacyNoticeFullUrl, '_blank');
    }
  };
  return /*#__PURE__*/React.createElement(Stack, {
    margin: "$4",
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 81,
      columnNumber: 5
    }
  }, /*#__PURE__*/React.createElement(Stack, {
    padding: "$4",
    backgroundColor: "$surface.container",
    border: "$1.5",
    shadow: "$1",
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 82,
      columnNumber: 7
    }
  }, /*#__PURE__*/React.createElement(Text, {
    testID: "ConnectedCommercialApi.primaryText",
    color: "$text.100",
    fontWeight: "$h4.strong",
    fontSize: "$h4.strong",
    marginBottom: "$2",
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 83,
      columnNumber: 9
    }
  }, i18n.t('ConnectedCommercialApi.content.connectedOAuthPartnerTile.primaryText')), /*#__PURE__*/React.createElement(RichText, {
    text: i18n.t('ConnectedOAuthPartner.content.oAuthPartnerTileHealthData.bodyText', {
      partnerName: partnerConnection.partner.name
    }),
    color: "$text.100",
    testID: "ConnectedCommercialApi.bodyText",
    fontToken: "$bodyBase.default",
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 93,
      columnNumber: 9
    }
  }), /*#__PURE__*/React.createElement(HStack, {
    justifyContent: "space-between",
    alignItems: "flex-start",
    marginTop: "$4",
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 102,
      columnNumber: 9
    }
  }, /*#__PURE__*/React.createElement(Text, {
    testID: "ConnectedCommercialApi.secondaryText",
    color: "$text.100",
    fontWeight: "$bodyBase.medium",
    fontSize: "$bodyBase.medium",
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 103,
      columnNumber: 11
    }
  }, i18n.t('ConnectedOAuthPartner.content.oAuthPartnerTileHealthData.secondaryText')), /*#__PURE__*/React.createElement(Stack, {
    onPress: () => setShowModalInfo(true),
    cursor: "pointer",
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 111,
      columnNumber: 11
    }
  }, /*#__PURE__*/React.createElement(IconInfo, {
    testID: "ConnectedCommercialApi.info-icon",
    size: "S",
    color: "$interactive.core.enabled",
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 112,
      columnNumber: 13
    }
  }))), /*#__PURE__*/React.createElement(Text, {
    testID: "ConnectedCommercialApi.connectedAt",
    marginTop: "$6",
    color: "$text.60",
    fontWeight: "$bodySmall.default",
    fontSize: "$bodySmall.default",
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 119,
      columnNumber: 9
    }
  }, i18n.t('ConnectedCommercialApi.content.connectedOAuthPartnerTile.bodyText', {
    time,
    monthDate
  })), /*#__PURE__*/React.createElement(Divider, {
    marginVertical: "$4",
    borderColor: "$neutral.40",
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 131,
      columnNumber: 9
    }
  }), footerLoading ? /*#__PURE__*/React.createElement(Stack, {
    width: "100%",
    display: "flex",
    alignItems: "center",
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 133,
      columnNumber: 11
    }
  }, /*#__PURE__*/React.createElement(LoadingSpinner, {
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 134,
      columnNumber: 13
    }
  })) : /*#__PURE__*/React.createElement(Link, {
    testID: "ConnectedCommercialApi.stopSharing-btn",
    onPress: onStopSharing,
    linkTextColor: "$support.danger.default",
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 137,
      columnNumber: 11
    }
  }, i18n.t('Global.modals.stopSharing.title')), /*#__PURE__*/React.createElement(InfoModal, {
    isOpen: showModalInfo,
    title: i18n.t('ConnectedOAuthPartner.modals.healthDataSharedBottomSheet.title'),
    content: i18n.t('ConnectedOAuthPartner.modals.healthDataSharedBottomSheet.body'),
    handleClose: () => setShowModalInfo(false),
    customModalStyle: {
      minHeight: '20vh',
      maxHeight: '20vh',
      overflow: 'auto'
    },
    onPressLinkContent: onPrivacyNoticeLinkClick,
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 146,
      columnNumber: 9
    }
  })), /*#__PURE__*/React.createElement(Text, {
    testID: "ConnectedCommercialApi.subtitle",
    marginTop: "$4",
    color: "$text.60",
    fontWeight: "$bodySmall.default",
    fontSize: "$bodySmall.default",
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 159,
      columnNumber: 7
    }
  }, i18n.t('ConnectedCommercialApi.subtitle')));
};
export default HealthDataCommercialApi;